<template>
  <!-- 移动端 -->
    <div class="dialogPage" v-title :data-title="this.$route.params.id=='mtxy'? '智能客服':'智能问答'" v-if="deviceType == '移动端'">
        <!-- 头部 logo -->
        <div class="dialog-header" :style="{'background-color': color}">
            <div>
                <h1 class="header-img">
                    <!-- <img :src="`@/assets/img/${$route.params.id}.jpg`" alt="" class="logoimg"/> -->
                    <img v-if="company_logo" :src="company_logo" alt="" class="logoimg"/>
                    <img v-else src="@/assets/img/avatar_xiaolingling@3x.png" alt="" class="logoimg"/>
                </h1>
                <span class="header-esurfing">
                    <!-- <span v-if="title!='智能问答系统'">{{title}}</span>  :class="{active:title!='智能问答系统'}"-->
                    <span>{{title || '智能客服'}}</span>
                </span>
            </div>
        </div>
        <!-- v-chat-scroll 保持可滚动内容滚动到底部的Vue指令插件 -->
        <div class="dialog-content" v-chat-scroll="{ always: true, smooth: true, notSmoothOnInit: true }">
            <!-- 欢迎语 -->
            <div class="dialog-welcome">
                <!-- 系统对话名称 -->
                <p class="welcome-img">
                    <span class="welcome-user">{{ nickname || '小智' }}</span>
                </p>
                <!-- 欢迎语 -->
                <p class="welcome-user">
                    <!-- <img v-if="robot_logo" :src="robot_logo" alt="" class="img" />
                    <img v-else src="@/assets/img/robot_icon.jpg" alt="" class="img" /> -->
                    <img src="@/assets/img/robot_icon.jpg" alt="" class="img" />
                    <span class="dialog-welcome-address">{{ greeting }}</span>
                </p>
            </div>
            <div class="dialog-chat">
                <div class="dialog-lst">
                    <div class="dialog-robot-list">
                        <div class="dialog-robot">
                            <div class="dialog-robot-user">
                              <span class="robot-user">{{ nickname || '小智' }}</span>
                            </div>
                            <div class="dialog-robot-img">
                                <!-- <img v-if="robot_logo" :src="robot_logo" alt="" class="robotimg"/>
                                <img v-else src="@/assets/img/robot_icon.jpg" alt="" class="robotimg"/> -->
                                <img src="@/assets/img/robot_icon.jpg" alt="" class="robotimg" />
                                <div class="robot-answer" :class="[questionHint.faq_type != 'normal' && questionHint.faq_type != 'sensitive' &&  questionHint.topk_qas != false && !questionHint.errcolor ? 'robotAnswer': '', ]">
                                    <div class="robot-address" @click="imagechange($event)">{{questionHint.answer}}</div>
                                    <p class="similarity" :key="index" v-for="(item, index) in questionHint.topk_qas" @click="similarity(item, index)">
                                      <span>{{ index + 1 }}：</span>
                                      <span style="font-size: 14px">{{ item.question }}</span>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 对话 -->
            <div class="dialog-chat">
                <div class="dialog-lst" v-for="(ele, index) in dialogData" :key="index">
                    <!-- 用户方输入内容 -->
                    <div class="dialog-desired" v-if="ele.issue">
                        <p class="dialog-user">
                          <span class="dialog-desired-address">{{ ele.issue }}</span>
                        </p>
                        <p class="user-img">
                          <!-- <img v-if="user_logo" :src="user_logo" alt="" class="img" />
                          <img v-else src="@/assets/img/people_icon.jpg" alt="" class="img" /> -->
                          <img src="@/assets/img/people_icon.jpg" alt="" class="img" />
                        </p>
                    <!-- <span class="dialog-desired-user">:客户</span> -->
                    </div>
                    <!-- 系统回复内容 -->
                    <div class="dialog-robot-list" v-if="ele.answer === 'padding-animation'">
                        <div class="dialog-robot">
                            <div class="dialog-robot-user">
                              <span class="robot-user">{{ nickname || '小智' }}</span>
                            </div>
                            <div class="dialog-robot-img">
                                <!-- <img v-if="robot_logo" :src="robot_logo" alt="" class="robotimg"/>
                                <img v-else src="@/assets/img/robot_icon.jpg" alt="" class="robotimg"/> -->
                                <img src="@/assets/img/robot_icon.jpg" alt="" class="robotimg"/>
                                <div class="loading-dot">
                                    <span class="dot dot1">●</span>
                                    <span class="dot dot2">●</span>
                                    <span class="dot dot3">●</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="dialog-robot-list" v-else-if="ele.answer && ele.answer !== 'padding-animation'">
                        <div class="dialog-robot">
                            <div class="dialog-robot-user">
                              <span class="robot-user">{{ nickname || '小智' }}</span>
                            </div>
                            <div v-if="!ele.default_questions" class="dialog-robot-img">
                                <!-- <img v-if="robot_logo" :src="robot_logo" alt="" class="robotimg"/>
                                <img v-else src="@/assets/img/robot_icon.jpg" alt="" class="robotimg"/> -->
                                <img src="@/assets/img/robot_icon.jpg" alt="" class="robotimg"/>
                                <div class="robot-answer" :class="[ele.faq_type != 'normal' && ele.faq_type != 'sensitive' &&  ele.topk_qas != false && !ele.errcolor ? 'robotAnswer': '', ]">
                                    <div class="robot-address" v-html="ele.answer.replace('\n\n', '').replaceAll('\n\n', '<br>')" @click="imagechange($event)">{{ele.answer}}</div>
                                    <!-- 图片放大 -->
                                    <div class="imgDolg" v-show="imgPreview.show" @click.stop="imgPreview.show = false">
                                        <i class="el-icon-close" @click.stop="imgPreview.show = false"></i>
                                        <img @click.stop="imgPreview.show = true" :src="imgPreview.img" />
                                    </div>
                                    <p class="similarity" v-for="(item, index) in ele.topk_qas" v-if="ele.faq_type != 'normal'" @click="similarity(item, index)">
                                      <span>相似问题{{ index + 1 }}：</span>
                                      <span style="font-size: 14px">{{ item.question }}</span>
                                    </p>
                                </div>
                            </div>
                            <div v-else class="dialog-robot-img">
                                <!-- <img v-if="robot_logo" :src="robot_logo" alt="" class="robotimg"/>
                                <img v-else src="@/assets/img/robot_icon.jpg" alt="" class="robotimg"/> -->
                                <img src="@/assets/img/robot_icon.jpg" alt="" class="robotimg"/>
                                <div class="robot-answer" :class="['robotAnswer' ]">
                                    <div class="robot-address" v-html="ele.answer.replace('\n\n', '').replaceAll('\n\n', '<br>')" @click="imagechange($event)">{{ele.answer}}</div>
                                    <p class="similarity" v-for="(item, index) in ele.default_questions" @click="similarity({question: item.content}, index)">
                                      <span>{{ index + 1 }}：</span>
                                      <span style="font-size: 14px">{{ item.content }}</span>
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="dialog-decision" v-if="ele.faq_type === 'normal'">
                            <button class="dialog-correct" :disabled ="ele.checked !== -1" :class="[(ele.checked === -1 || ele.checked === 0) && 'error',ele.checked === 1 && 'correct', ]" @click.once="errsolved(ele, 0)">
                              解决
                            </button>
                            <button class="dialog-error" :disabled ="ele.checked !== -1" :class="[(ele.checked === -1 || ele.checked === 1) && 'error', ele.checked === 0 && 'correct',]" @click.once="errsolved(ele, 1)">
                              未解决
                            </button>
                        </div>
                    </div>
                     <!-- 结束语 -->
                    <div class="dialog-endwelcome" v-if="ele.text">
                        <p class="endwelcome-img">
                            <span class="endwelcome-name">{{ nickname || '小智' }}</span>
                        </p>
                        <p class="endwelcome-user">
                            <!-- <img v-if="robot_logo" :src="robot_logo" alt="" class="endimg"/>
                            <img v-else src="@/assets/img/robot_icon.jpg" alt="" class="endimg"/> -->
                            <img src="@/assets/img/robot_icon.jpg" alt="" class="endimg"/>
                            <span class="dialog-endwelcome-address">{{ ele.text }}</span>
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <div class="inpText">
            <el-input @keyup.enter.native="sendData()" type="textarea" placeholder="输入文字与我对话吧~" v-model.trim="dialogtext">
            </el-input>
            <el-button type="primary" @click="sendData()" :class="[dialogtext ? 'class1' : 'class2']" >发送</el-button>
        </div>
    </div>

  <!-- pc端 -->
    <div class="pc-dialogPage" v-title :data-title="this.$route.params.id=='mtxy'? '智能客服':'智能问答'" v-else>
        <div class="pc-dialog-header" :style="{'background-color': color}">
            <div>
                <h1 class="pc-header-img">
                    <img v-if="company_logo" :src="company_logo" alt="" class="pc-logoimg"/>
                    <img v-else src="@/assets/img/avatar_xiaolingling@3x.png" alt="" class="pc-logoimg"/>
                </h1>
                <span class="pc-header-esurfing">
                    <!-- <span v-if="title!='智能问答系统'"></span>  :class="{active:title!='智能问答系统'}"-->
                    <span>{{title || '智能客服'}}</span>
                </span>
            </div>
            <span>
                <!-- <span class="iconfont icon-zuidahua1"></span>
                <span class="iconfont icon-guanbi1 close" @click="close"></span> -->
            </span>
        </div>
        <div class="pc-dialog-content" v-chat-scroll="{ always: true, smooth: true, notSmoothOnInit: true }">
                <!-- 欢迎语 -->
            <div class="pc-dialog-welcome">
                <p class="pc-welcome-img">
                    <span class="pc-welcome-user">{{ nickname || '小智' }}</span>
                </p>
                <p class="pc-welcome-user">
                    <!-- <img v-if="robot_logo" :src="robot_logo" alt="" class="pc-img"/>
                    <img v-else src="@/assets/img/robot_icon.jpg" alt="" class="pc-img"/> -->
                    <img src="@/assets/img/robot_icon.jpg" alt="" class="pc-img" />
                    <span class="pc-dialog-welcome-address">{{ greeting }}</span>
                </p>
            </div>
            <div class="pc-dialog-chat">
                <div class="pc-dialog-lst">
                    <!-- 系统回复 -->
                    <div class="pc-dialog-robot-list">
                        <div class="pc-dialog-robot">
                            <div class="pc-dialog-robot-user">
                                <span class="pc-robot-user">{{ nickname || '小智' }}</span>
                            </div>
                            <div class="pc-dialog-robot-img">
                                <!-- <img v-if="robot_logo" :src="robot_logo" alt="" class="pc-robotimg"/>
                                <img v-else src="@/assets/img/robot_icon.jpg" alt="" class="pc-robotimg"/> -->
                                <img src="@/assets/img/robot_icon.jpg" alt="" class="pc-robotimg" />
                                <div class="pc-robot-answer" :class="[questionHint.faq_type != 'normal' && questionHint.faq_type != 'sensitive' && questionHint.topk_qas != false && !questionHint.errcolor && questionHint.faq_type != 'continue_unanswer'? 'pc-robotAnswer' : '', ]">
                                    <div class="pc-robot-address" @click="imagechange($event)">{{questionHint.answer}}</div>
                                    <p class="pc-similarity" v-for="(item, index) in questionHint.topk_qas"  :key="index" @click="similarity(item, index)">
                                        <span>{{ index + 1 }}：</span>
                                        <span style="font-size: 14px">{{ item.question }}</span>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 对话 -->
            <div class="pc-dialog-chat">
                <div class="pc-dialog-lst" v-for="(ele, index) in dialogData">
                    <!-- 用户内容 -->
                    <div class="pc-dialog-desired" v-if="ele.issue">
                        <p class="pc-dialog-user">
                            <span class="pc-dialog-desired-address">{{ ele.issue }}</span>
                        </p>
                        <p class="pc-user-img">
                            <!-- <img v-if="user_logo" :src="user_logo" alt="" class="pc-img" />
                            <img v-else src="@/assets/img/people_icon.jpg" alt="" class="pc-img" /> -->
                            <img src="@/assets/img/people_icon.jpg" alt="" class="pc-img" />
                        </p>
                        <!-- <span class="pc-dialog-desired-user">:客户</span> -->
                    </div>
                    <!-- 系统回复 -->
                    <div class="pc-dialog-robot-list" v-if="ele.answer === 'padding-animation'">
                        <div class="pc-dialog-robot">
                            <div class="pc-dialog-robot-user">
                              <span class="pc-robot-user">{{ nickname || '小智' }}</span>
                            </div>
                            <div class="pc-dialog-robot-img">
                                <!-- <img v-if="robot_logo" :src="robot_logo" alt="" class="robotimg"/>
                                <img v-else src="@/assets/img/robot_icon.jpg" alt="" class="robotimg"/> -->
                                <img src="@/assets/img/robot_icon.jpg" alt="" class="pc-robotimg"/>
                                <div class="loading-dot">
                                    <span class="dot dot1">●</span>
                                    <span class="dot dot2">●</span>
                                    <span class="dot dot3">●</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="pc-dialog-robot-list" v-if="ele.answer && ele.answer !== 'padding-animation'">
                        <div class="pc-dialog-robot">
                            <div class="pc-dialog-robot-user">
                                <span class="pc-robot-user">{{ nickname || '小智' }}</span>
                            </div>
                            <div v-if="!ele.default_questions" class="pc-dialog-robot-img">
                                <!-- <img v-if="robot_logo" :src="robot_logo" alt="" class="pc-robotimg"/>
                                <img v-else src="@/assets/img/robot_icon.jpg" alt="" class="pc-robotimg"/> -->
                                <img src="@/assets/img/robot_icon.jpg" alt="" class="pc-robotimg" />
                                <div class="pc-robot-answer" :class="[ele.faq_type != 'normal' && ele.faq_type != 'sensitive' && ele.topk_qas != false && !ele.errcolor && ele.faq_type != 'continue_unanswer'? 'pc-robotAnswer' : '', ]">
                                    <div class="pc-robot-address" v-html="ele.answer.replace('\n\n', '').replaceAll('\n\n', '<br>')" @click="imagechange($event)">{{ele.answer}}</div>
                                    <!-- 图片放大 -->
                                    <div class="pc-imgDolg" v-show="imgPreview.show" @click.stop="imgPreview.show = false">
                                        <i class="el-icon-close" @click.stop="imgPreview.show = false"></i>
                                        <img @click.stop="imgPreview.show = true" :src="imgPreview.img" />
                                    </div>
                                    <p class="pc-similarity" v-for="(item, index) in ele.topk_qas"  :key="index" v-if="ele.faq_type != 'normal'&&ele.faq_type != 'continue_unanswer'" @click="similarity(item, index)">
                                        <span>相似问题{{ index + 1 }}：</span>
                                        <span style="font-size: 14px">{{ item.question }}</span>
                                    </p>
                                </div>
                            </div>
                            <div v-else class="pc-dialog-robot-img">
                                <!-- <img v-if="robot_logo" :src="robot_logo" alt="" class="pc-robotimg"/>
                                <img v-else src="@/assets/img/robot_icon.jpg" alt="" class="pc-robotimg"/> -->
                                <img src="@/assets/img/robot_icon.jpg" alt="" class="pc-robotimg" />
                                <div class="pc-robot-answer" :class="['pc-robotAnswer']">
                                    <div class="pc-robot-address" v-html="ele.answer.replace('\n\n', '').replaceAll('\n\n', '<br>')">{{ele.answer}}</div>
                                    <p class="pc-similarity" v-for="(item, index) in ele.default_questions"  :key="index"  @click="similarity({question: item.content}, index)">
                                        <span>{{ index + 1 }}：</span>
                                        <span style="font-size: 14px">{{ item.content }}</span>
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="pc-dialog-decision" v-if="ele.faq_type === 'normal'">
                            <!-- <button class="pc-dialog-correct" :class="[(ele.checked === -1 || ele.checked === 1) && 'pc-correct',ele.checked === 0 && 'pc-error',]" @click.once="succsolved(ele, index)">
                              解决
                            </button> -->
                            <button class="pc-dialog-correct"  :disabled ="ele.checked !== -1" :class="[(ele.checked === -1 || ele.checked === 0) && 'pc-error',ele.checked === 1 && 'pc-correct',]" @click.once="errsolved(ele,0)">
                              解决
                            </button>
                            <button class="pc-dialog-error"  :disabled ="ele.checked !== -1" :class="[(ele.checked === -1 || ele.checked === 1) && 'pc-error',ele.checked === 0 && 'pc-correct',]" @click.once="errsolved(ele, 1)">
                              未解决
                            </button>
                        </div>
                    </div>
                    <div class="pc-dialog-endwelcome" v-if="ele.text">
                        <p class="pc-endwelcome-img">
                            <span class="pc-endwelcome-name">{{ nickname }}</span>
                        </p>
                        <p class="pc-endwelcome-user">
                            <!-- <img v-if="robot_logo" :src="robot_logo" alt="" class="pc-endimg"/>
                            <img v-else src="@/assets/img/robot_icon.jpg" alt="" class="pc-endimg"/> -->
                            <img src="@/assets/img/robot_icon.jpg" alt="" class="pc-endimg" />
                            <span class="pc-dialog-endwelcome-address">{{ ele.text }}</span>
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <div class="pc-inpText">
            <el-input @keyup.enter.native="sendData()" type="textarea" placeholder="输入文字与我对话吧~" v-model.trim="dialogtext">
            </el-input>
            <el-button type="primary" @click="sendData()" :class="[dialogtext ? 'pc-class1' : 'pc-class2']">发送</el-button>
        </div>
    </div>
</template>

<script>
import {dialog,unsolved,setting,getQuestions, sendMsg} from "../../views/api/dialogrobot/dialogrobot.js";
import questionHint from './question'
import mtxy from "@/assets/img/mtxy.jpg"
import zncj from "@/assets/img/zncj.jpg"
import dbsf from "@/assets/img/dbsf.jpg"
//解密
import Jsrsasign, { KJUR, hex2b64 } from "jsrsasign";
export default {
    data() {
        return {
            mtxy,
            zncj,
            dbsf,
            //对话内容集合
            dialogData: [],
            //输入文本
            dialogtext: "",
            btn: false,
            //当前对话id
            dialogid: "",
            //识别移动端还是pc
            deviceType: "",
            //昵称
            nickname: "",
            //欢迎语
            greeting: "",
            //结束语
            endState:[],
            //欢迎语 昵称 参数
            nameID: "",
            //定时器标识
            timer:null,
            // 图片放大
            imgPreview:{
                show:false,
                img:""
            },
            isDisabled:false,
            Disabled:false,
            //随机字符串
            randomString:"",
            questionHint,
            api_key: '',
            signPrivateKey: '',
            title: '',
            color: '',
            company_logo: '',
            robot_logo: '',
            user_logo: ''
        };
    },
    mounted() {
        if (this.isMobile()) {
            this.deviceType = "移动端";
        } else {
            this.deviceType = "pc端";
        }
        if(this.timer){
            window.clearTimeout(this.timer)
            this.timer = null
        }
        
        this.api_key = config[this.$route.params.id+'_key']
        this.signPrivateKey = config[this.$route.params.id]
        this.getRadomString() //生成随机字符串
        // this.myBrowser()
        // this.getwelcome();
        this.setName()
        // this.getQuestions()
    },
    methods: {
        // 查询提示问题
        getQuestions(){
            this.questionsEncrypt()
            getQuestions().then((res) => {
                if (res.data.errno == 2000) {
                    let questions = {
                        answer: `欢迎使用${this.title}，您是否想了解以下常见问题`,
                        topk_qas: []
                    }
                    res.data.results.questions.map((item) => {
                        let obj = {
                            question: item.content
                        }
                        questions.topk_qas.push(obj)
                    })
                    this.questionHint = questions
                    
                } else {
                    
                }
            }).catch(() => {
            
            });
        },
        //查询提示问题加密
        questionsEncrypt() {
            // 发送问题加密
            let method = "GET";
            let url = "/api/knlgbases/qas/?sort=qid_desc&&page=1&&page_size=5&&samples=open";
            let timestamp = Date.parse(new Date()).toString().slice(0, 10);
            let body = "";
            let signData =
                method + "\n" + url + "\n" + timestamp + "\n" + body + "\n";
            let signature = this.signature(signData);
            let token = `SHA256-RSA2048 api_key='${this.api_key}',timestamp='${timestamp}',signature='${signature}'`;
            // 请求问答服务
            sessionStorage.setItem("token", token);
        },
        close(){
            document.getElementById('link_container').style.height= '0px'
        },
        //判断设备类型
        isMobile() {
            let flag = navigator.userAgent.match(
              /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
            );
            // localStorage.setItem('isiphone',flag)
            // console.log(flag)
            return flag;
        },
        //生成随机字符串
        getRadomString(){
            function randomString(len) {
                len = len || 32;
                /****默认去掉了容易混淆的字符oOLl,9gq,Vv,Uu,I1****/
                var $chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678';
                var maxLen = $chars.length;
                var str = '';
                for (var i = 0; i < len; i++) {
                    str += $chars.charAt(Math.floor(Math.random() * maxLen));
                    
                }
                return str;
            }
            this.randomString = randomString(); 
            
                // console.log($res)
        } ,
        //发送消息
        sendData() {
            // 替换 换行字符，限制内容不可换行
            var reg = new RegExp( '\n' , "g" )
            this.dialogtext = this.dialogtext.replace(/[\\n]/g,'')
            this.dialogtext = this.dialogtext.replace(reg , '' );
            // 清除定时器
            if(this.timer){
                window.clearTimeout(this.timer)
                this.timer = null
            }

            if (this.dialogtext) { // 有输入内容执行
                // 将输入内容添加到对话内容集合
                this.dialogData.push({ issue: this.dialogtext, checked: -1 });
                let dialogtext = ''
                if(+ this.dialogtext < 6){
                   dialogtext =  this.questionHint.topk_qas[+ this.dialogtext - 1].question
                }else{
                    dialogtext = this.dialogtext
                }
                this.searchQuestion(dialogtext,this.randomString);
                this.dialogData.push({ answer: 'padding-animation', checked: -1 });
                sendMsg({keyword: this.dialogtext}).then((response) => {
                    this.dialogtext = "";
                    if (response.data.code === 200) {
                        this.dialogData = this.dialogData.slice(0, -1)
                        this.dialogData.push({ ...response.data.data, checked: -1 });
                    } else {
                        this.dialogData = this.dialogData.slice(0, -1)
                        this.dialogData.push({ ...response.data.data, checked: -1 });
                        // this.$message.error(response.data.errmsg);
                    }
                    // if(!this.timer){ // 开启定时器，18秒内无操作，执行
                    //     this.timer = window.setTimeout(()=>{
                    //         this.getendSta() // 获取结束语
                    //         this.getRadomString() // 重新生成随机字符串
                    //     },180000)
                    // }
                }).catch((error) => {
                    this.$message.error("请求失败");
                    this.dialogData.push({ answer: "网络请求错误",  checked: -1,  errcolor: "1",});
                });
            }else {
                this.$message.error("内容不能为空");
            }
        },
        //获取昵称
        async setName() {
            // await this.getcolor()
            // await this.gettitle()
            await this.getwelcome()
            // await this.getQuestions()
            // await this.getcompany_logo()
            // await this.getrobot_logo()
            // await this.getuser_logo()
            this.nameID = "qa_nickname";
            console.log(1)
            this.nameEncrypt(this.nameID);
            console.log(2)
            return
            setting(this.nameID).then((response) => {
                if (response.data.errno == 2000) {
                    this.nickname = response.data.results.value;
                } else {
                    this.$message.error(response.data.errmsg);
                }
            }).catch((error) => {
                this.$message.error("获取数据失败");
            });
        },
        getcompany_logo(){
            this.nameID = "qa_company_logo";
            this.nameEncrypt(this.nameID);
            setting(this.nameID).then((response) => {
                if (response.data.errno == 2000) {
                    this.company_logo = this[this.$route.params.id]//response.data.results.value;
                }else {
                    this.$message.error(response.data.errmsg);
                    this.company_logo = ''
                }
            }).catch((error) => {
                this.$message.error("获取数据失败");
                this.company_logo = ''
            });
        },
        getrobot_logo(){
            this.nameID = "qa_robot_logo";
            this.nameEncrypt(this.nameID);
            setting(this.nameID).then((response) => {
                if (response.data.errno == 2000) {
                    this.robot_logo = response.data.results.value;
                }else {
                    this.$message.error(response.data.errmsg);
                    this.robot_logo = ''
                }
            }).catch((error) => {
                this.robot_logo = ''
                this.$message.error("获取数据失败");
            });
        },
        getuser_logo(){
            this.nameID = "qa_user_logo";
            this.nameEncrypt(this.nameID);
            setting(this.nameID).then((response) => {
                if (response.data.errno == 2000) {
                    this.user_logo = response.data.results.value;
                }else {
                    this.$message.error(response.data.errmsg);
                    this.user_logo = ''
                }
            }).catch((error) => {
                this.$message.error("获取数据失败");
                this.user_logo = ''
            });
        },
        //获取欢迎语
        getwelcome(){
            this.nameID = "qa_welcomemsg";
            this.nameEncrypt(this.nameID);
            this.greeting = '欢迎访问智能客服'
            return
            setting(this.nameID).then((response) => {
                if (response.data.errno == 2000) {
                    this.greeting = response.data.results.value;
                }else {
                    this.$message.error(response.data.errmsg);
                }
            }).catch((error) => {
                this.$message.error("获取数据失败");
            });
        },
        //获取标题
        gettitle(){
            this.nameID = "qa_title";
            this.nameEncrypt(this.nameID);
            setting(this.nameID).then((response) => {
                if (response.data.errno == 2000) {
                    this.title = response.data.results.value;
                    console.log(this.title)
                }else {
                    this.$message.error(response.data.errmsg);
                }
            }).catch((error) => {
                this.$message.error("获取数据失败");
            });
        },
        //获取主题色值
        getcolor(){
            this.nameID = "qa_color";
            this.nameEncrypt(this.nameID);
            setting(this.nameID).then((response) => {
                if (response.data.errno == 2000) {
                    this.color = response.data.results.value;
                }else {
                    this.$message.error(response.data.errmsg);
                }
            }).catch((error) => {
                this.$message.error("获取数据失败");
            });
        },
        //获取结束语
        getendSta(){
            this.nameID = "qa_endingmsg";
            this.nameEncrypt(this.nameID);
            setting(this.nameID).then((response) => {
                console.log(response)
                if (response.data.errno == 2000) {
                    this.dialogData.push({text:response.data.results.value});
                } else {
                    this.$message.error(response.data.errmsg);
                }
            }).catch((error) => {
                this.$message.error("获取数据失败");
            });
        },
        //昵称加密
        nameEncrypt(val) {
            console.log(val);
            // 发送问题加密
            let method = "GET";
            let url = "/api/settings/?key=" + val;
            let timestamp = Date.parse(new Date()).toString().slice(0, 10);
            let body = "";
            let signData =
                method + "\n" + url + "\n" + timestamp + "\n" + body + "\n";
                console.log(3)
            let signature = this.signature(signData);
            console.log(4)
            let token = `SHA256-RSA2048 api_key='${this.api_key}',timestamp='${timestamp}',signature='${signature}'`;
            // 请求问答服务
            sessionStorage.setItem("token", token);
        },
        //图片点击放大
        imagechange(e){
            // console.log(e,e.target,e.target.src)
            if(e.target.nodeName == "IMG"){
                this.imgPreview.img = e.target.src
                this.imgPreview.show = true
            }
        },
        //相似问题
        similarity(item, index) {
            if(this.timer){
                window.clearTimeout(this.timer)
                this.timer = null
            }
            this.dialogData.push({ issue: item.question, checked: -1 });
            this.searchQuestion(item.question,this.randomString);
            this.dialogData.push({ answer: 'padding-animation', checked: -1 });
            sendMsg({keyword: item.question}).then((response) => {
                console.log(response.data)
                if (response.data.code === 200) {
                    this.dialogData = this.dialogData.slice(0, -1)
                    this.dialogData.push({ ...response.data.data, checked: -1 });
                    console.log(this.dialogData)
                    // this.dialogID = response.data.results.faq_log_id;
                } else {
                    this.dialogData = this.dialogData.slice(0, -1)
                    this.dialogData.push({ ...response.data.data, checked: -1 });
                    this.$message.error(response.data.errmsg);
                }
                // if(!this.timer){
                //     this.timer = window.setTimeout(()=>{
                //         this.getendSta()
                //         this.getRadomString()
                //     },180000)
                // }
            })
            .catch((error) => {
              this.$message.error("请求失败");
              this.dialogData.push({
                answer: "网络请求错误",
                checked: -1,
                errcolor: "1",
              });
            });
        },
        //正确识别
        // succsolved(ret,index){
        //     console.log("内容正确",ret)
        //     ret.checked = 1;
            // unsolved(this.dialogID).then(response=>{
            //     console.log("----",response)
            //     if(response.data.errno === 2000){
            //         this.$message.success("感谢你的支持")
            //     }else{
            //         this.$message.error("请求失败")
            //     }
            // }).catch(error=>{
            //     this.$message.error("数据错误")
            // })
        // },
        // 点击解决、未解决调用
        errsolved(ret, index) {
            /* 
                checked: 解决、未解决按钮操作标识
                checked === -1 解决、未解决按钮可以点击操作，否则加禁用属性
                checked === -1 || checked === 0 解决按钮加可以点击操作样式，checked === 1 加禁用样式
                checked === -1 || checked === 1 未解决按钮加可以点击操作样式，checked === 0 加禁用样式
            */
            if(index === 0 ){ // 解决，不做处理
                ret.checked = 1
            }else{
                let dialogID = ret.faq_log_id;
                this.dialogid = dialogID;
                this.btn = true; //标识
                this.searchQuestion();
                unsolved(dialogID).then((response) => {
                    if (response.data.errno === 2000) {
                        ret.checked = 0;
                        this.$message.warning("我会努力学习，下次帮到你");
                    } else {
                        this.$message.error(response.data.errmsg);
                    }
                })
                .catch((error) => {
                  this.$message.error("数据错误");
                }); 
            }
            console.log(ret,index)
           
        },
        //错误
        // errsolved(ret, index) {
        //     console.log(ret,index)
        //     let dialogID = ret.faq_log_id;
        //     this.dialogid = dialogID;
        //     this.btn = true; //标识
        //     this.searchQuestion();
        //     unsolved(dialogID).then((response) => {
        //         if (response.data.errno === 2000) {
        //             ret.checked = 0;
        //             this.$message.warning("我会努力学习，下次帮到你");
        //         } else {
        //             this.$message.error(response.data.errmsg);
        //         }
        //     })
        //     .catch((error) => {
        //       this.$message.error("数据错误");
        //     });
        // },
        //加密
        searchQuestion(question,nonce_str) {
            if (!this.btn) {
                // 发送问题加密
                let method = "POST";
                let url = "/api/search/";
                let timestamp = Date.parse(new Date()).toString().slice(0, 10);
                let body = JSON.stringify({ question: question, nonce_str: nonce_str });
                let signData =
                    method + "\n" + url + "\n" + timestamp + "\n" + body + "\n";
                let signature = this.signature(signData);
                
                let token = `SHA256-RSA2048 api_key='${this.api_key}',timestamp='${timestamp}',signature='${signature}'`;
                // 请求问答服务
                sessionStorage.setItem("token", token);
            }else {
                //点击未解决加密
                let timestamp = Date.parse(new Date())
                  .toString()
                  .slice(0, 10);
                let bodyText = "";
                let method = "PUT";
                let url = "/api/like/logs/" + this.dialogid + "/";
                let signData =
                  method + "\n" + url + "\n" + timestamp + "\n" + bodyText + "\n";
                let signature = this.signature(signData);
                let token = `SHA256-RSA2048 api_key='${this.api_key}',timestamp='${timestamp}',signature='${signature}'`;
                sessionStorage.setItem("token", token);
                this.btn = false;
            }
        },
        //私钥加签
        signature(signData) {
            let signPrivateKey = this.signPrivateKey;
            let sig = new KJUR.crypto.Signature({
                alg: "SHA256withRSA",
                prov: "cryptojs/jsrsa",
                prvkeypem: signPrivateKey,
            });
            console.log(signPrivateKey)
            console.log(9)
            var hashAlg = "sha256"; // 设置sha1
            console.log(6,signData, hashAlg)
            var sign = sig.signString(signData, hashAlg); // 加签
            console.log(7)
            sign = hex2b64(sign);
            console.log(8)
            return sign;
        },
    },
    destroyed(){
        if(this.timer){
            window.clearTimeout(this.timer)
            this.timer = null
        }
    }
};
</script>

<style lang="less" scoped>
  
    @import "../../assets/css/dialogrobot/dialogrobot.css";
    @import "../../assets/css/pcDialogrobot/pcDialogrobot.css";

    @media screen and (max-height:768px) {
        .pc-dialogPage {
            width: 660px;
            // height: 620px;
            height: 580px;
                height: 480px;
            margin: 20px auto !important; /*For Firefox*/
            margin: 0px auto; /*For IE*/
        }
    }
    @media screen and (min-height: 769px) and (max-height:860px) {
        .pc-dialogPage {
            width: 860px;
            height: 670px;
            margin: 50px auto;
        }
    }
    @media screen and (height: 550px) {
        .pc-dialogPage {
            width: 450px;
            // height: 620px;
            // height: 580px;
            height: 550px;
            margin: 0px auto !important; /*For Firefox*/
            margin: 0px auto; /*For IE*/
        }
    }
    @media screen and (height: 40px) {
        .pc-dialogPage {
            width: 100%;
            // height: 620px;
            // height: 580px;
            height: 520px;
            margin: 0px auto !important; /*For Firefox*/
            margin: 0px auto; /*For IE*/
        }
    }
    @media screen and (min-height: 861px) and (max-height:900px) {
        .pc-dialogPage {
            width: 860px;
            height: 760px;
            margin: 20px auto;
        }
    }
    @media screen and (min-height: 901px) and (max-height:959px) {
        .pc-dialogPage {
            width: 860px;
            height: 750px;
            margin: 60px auto;
        }
    }
    @media screen and (min-height: 960px) {
        .pc-dialogPage {
            width: 860px;
            height: 820px;
            margin: 60px auto;
        }
    }
    /* 三点加载动画 */
.loading-dot {
  display: flex;
  gap: 6px;
  font-size: 18px;
  color: #999;
}
.dot {
  animation: dotJump 1.4s infinite ease-in-out;
}
.dot1 { animation-delay: 0s; }
.dot2 { animation-delay: 0.2s; }
.dot3 { animation-delay: 0.4s; }

@keyframes dotJump {
  0%, 80%, 100% { transform: translateY(0); }
  40% { transform: translateY(-6px); }
}
</style>
